import { pathFor } from '@nexa/content';
import { useLocale } from '@/core/i18n';

/**
 * Trả hàm dựng anchor tới một section của TRANG CHỦ, dùng được từ MỌI trang.
 *
 * Vì sao không dùng `href="#id"` trần: fragment trần giải theo URL **hiện tại**, nên trên
 * `/vi/privacy/` nó thành `/vi/privacy/#id` — anchor đó không tồn tại và người bấm không đi đâu
 * cả. `Header` / `MobileDrawer` / `Footer` render trên MỌI trang, nên chúng không được phép dùng
 * fragment trần; ba file đó từng dùng và đó là bug.
 *
 * Vì sao trả CHUỖI cho `<a>` chứ không bọc `<Link>`: app này KHÔNG có cơ chế cuộn tới hash —
 * `useLocation` / `ScrollRestoration` / `scrollIntoView` đều không tồn tại trong `apps/web/src`
 * (đã grep). `<Link>` sẽ điều hướng client-side rồi ĐỨNG YÊN, tức chữa trang pháp lý bằng cách
 * làm hỏng trang chủ. Với `<a href="/vi/#id">` thì trình duyệt tự xử đúng cả hai ca: cùng
 * document ⇒ cuộn tại chỗ, không tải lại; khác document ⇒ tải trang chủ rồi cuộn. Không cần
 * thêm hạ tầng nào.
 *
 * Contract §1.1 (*"liên kết nội bộ luôn đi qua `PageLink` với `PageId`, không viết URL tay"*):
 * đường dẫn ở đây lấy từ `pathFor('home', locale)` — tức vẫn là bảng route, không phải URL gõ tay.
 */
export function useHomeAnchor(): (idOrHash: string) => string {
  const locale = useLocale();
  const home = pathFor('home', locale);
  return (idOrHash) => `${home}#${idOrHash.replace(/^#/, '')}`;
}
